import axios from "axios";

console.info("DPD code loaded 6");

const loadButton = document.querySelector("#lookup-dpd-stores");
const searchForm = document.querySelector("#find-dpd-store-form");
const dpdResultsContainer = document.getElementById("dpdLocatorWrapper");
const listOfStoresContainer = document.getElementById(
  "store-get-rendered-here"
);
const showMoreButton = document.getElementById("showMoreStoresButton");
const dpdDropOffForm = document.getElementById("dpd-dropoff-form");

if (dpdDropOffForm) {
  const getSessionKey = () => {
    let sessionKey = sessionStorage.getItem("sessionKey");
    if (!sessionKey) {
      sessionKey =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem("sessionKey", sessionKey);
    }
    return sessionKey;
  };

  dpdDropOffForm.addEventListener("submit", () => {
    /* 
    I'm not doing this at the mo as we have Cex store drop off and DPD drop off but 
    no way to know if a user checked out as a Cex store or not. So I'm moving this 
    to the drop off step of the quote form, if a user picks a drop off point I'm 
    taking that as them being keen so will record it as a purchase even though it 
    might not be.
    
    // Fire in a "purchase" event for tracking our spend
    const fault = dpdDropOffForm.querySelector('input[name="faults"]')?.value;
    const manufacture = dpdDropOffForm.querySelector(
      'input[name="manufacture"]'
    )?.value;
    const model = dpdDropOffForm.querySelector('input[name="model"]')?.value;
    const deviceType = dpdDropOffForm.querySelector(
      'input[name="deviceType"]'
    )?.value;
    const quotedPrice = dpdDropOffForm.querySelector(
      'input[name="quotedPrice"]'
    )?.value;

    const payload = {
      currency: "GBP",
      value: price,
      transaction_id: getSessionKey(),
      shipping: 4.99,
      items: [
        {
          item_id: `${deviceType}-${manufacture}-${model}-${fault}`,
          item_name: "${deviceType}, ${brand}, ${model}, ${fault}",
          item_brand: manufacture,
          item_category: deviceType,
          item_category2: manufacture,
          item_category3: model,
          item_category4: fault,
          price: quotedPrice,
        },
      ],
    };

    if (window.gtag !== undefined) {
      window.gtag("event", "purchase", payload);
    }
*/
    const submitLoadingBar = document.getElementById("submit-loadbar");
    submitLoadingBar.style.display = "flex";
  });
}

const ajaxLoadMore = () => {
  let searchInput = document.getElementById("postcodeToSearchMapFor");
  let postcodeAddressLookupField = document.getElementById("search-postcode");
  postcodeAddressLookupField.value = searchInput.value;
  let searchString = searchInput.value;
  let loadingBar = document.querySelector("#stores-loadbar");
  if (loadingBar) {
    loadingBar.style.display = "flex";
  }

  const storeLookup = (postcode, attempts = 0) => {
    console.info(
      "Searching for postcode " + postcode + ", attempt " + (attempts + 1)
    );
    let params = new URLSearchParams();
    params.append("postcode", postcode);
    params.append("action", "dpd_store_lookup");

    const makeRequest = () => {
      return axios
        .get("/wp-admin/admin-ajax.php", { params, timeout: 28000 })
        .then((res) => {
          console.log("Full response:", res);
          console.log("Response data:", res.data);

          if (res.data && res.data.data && res.data.success) {
            let data = res.data.data;
            let results = [];
            console.info("Data", { data, isString: typeof data === "string" });
            if (typeof data === "string") {
              try {
                results = JSON.parse(data).results.filter(
                  (loc) => loc.pickupLocation.dropOffDigital === true
                );
              } catch (e) {
                console.error("Failed to parse results:", e);
              }
            }

            console.info("Parsed Results", results);

            dpdResultsContainer.style.display = "block";
            loadingBar.style.display = "none";

            if (results.length > 0) {
              // Render map and results list
              renderMapAndList(results);
            } else {
              // No more posts to load
              listOfStoresContainer.innerHTML =
                '<div class="no-stores content-wrap"><h3 class="medium-heading gradient-text mg-bt-reg centre-text">' +
                "No stores found" +
                '</h3><p class="body-large-light centre-text">' +
                "It does not look like we have a store close to your location. Get in touch and we can work out how to get your item to us." +
                "</p></div>";
            }
            dpdResultsContainer.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          } else {
            throw new Error("Failed to get results");
          }
        })
        .catch((error) => {
          if (attempts < 2) {
            // Max 3 attempts (0, 1, 2)
            console.log(`Attempt ${attempts + 1} failed. Retrying...`, error);
            return new Promise((resolve) => setTimeout(resolve, 1000)) // 1 second pause
              .then(() => storeLookup(postcode, attempts + 1));
          } else {
            console.error("Max attempts reached. Request failed:", error);
            loadingBar.style.display = "none";
            throw error;
          }
        });
    };

    return makeRequest(); // Call the makeRequest function and return its result
  };

  storeLookup(searchString).catch((error) => {
    console.error("All attempts failed:", error);
    listOfStoresContainer.innerHTML =
      '<div class="error">Failed to load stores. Please try again later.</div>';
  });
};

const renderMapAndList = (results) => {
  const markers = [];
  const listItems = [];

  console.info("Results to map", results);

  const containerWrapper = document.createElement("div");
  containerWrapper.id = "map-list-wrapper";

  const mapContainer = document.createElement("div");
  mapContainer.id = "map";

  const listContainer = document.createElement("div");
  listContainer.id = "store-list";

  listOfStoresContainer.innerHTML = "";
  containerWrapper.appendChild(mapContainer);
  containerWrapper.appendChild(listContainer);
  listOfStoresContainer.appendChild(containerWrapper);

  // Initialize Google Map
  const map = new google.maps.Map(mapContainer, {
    mapId: "DPDMap",
    zoom: 14,
    center: {
      lat: results[0].pickupLocation.addressPoint.latitude,
      lng: results[0].pickupLocation.addressPoint.longitude,
    },
  });

  function highlightListItem(index) {
    listItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add("highlighted");
      } else {
        item.classList.remove("highlighted");
      }
    });
    listItems[index].scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function highlightMarker(index) {
    markers.forEach((m, i) => {
      if (i === index) {
        m.content.style.backgroundColor = "#FF0000"; // Change color to red
        setTimeout(() => (m.content.style.backgroundColor = "#4285F4"), 1500); // Change back after 1.5 seconds
      }
    });
  }
  // Ensure map resizes correctly
  google.maps.event.addListenerOnce(map, "idle", () => {
    google.maps.event.trigger(map, "resize");
  });

  function createMarkerContent(label) {
    const content = document.createElement("div");
    content.classList.add("mapMarker");
    content.textContent = label;
    return content;
  }

  let selectedStore = null;
  const formContainer = document.getElementById("dpd-form-container");
  const storeDetails = document.getElementById("selected-store-details");

  function updateSelectedStore(index) {
    highlightListItem(index);
    highlightMarker(index);
    selectedStore = results[index];
    listItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add("selected");
        storeDetails.innerHTML = item.innerHTML;
        storeDetails.querySelector("button").remove(); // Remove our "Drop off here" button
      } else {
        item.classList.remove("selected");
      }
    });

    /*    storeDetails.innerHTML = `
    <p>
      ${selectedStore.pickupLocation.shortName}<br/>
      ${selectedStore.pickupLocation.address.street},<br/>
      ${(selectedStore.pickupLocation.address.town ? selectedStore.pickupLocation.address.town + ",<br/>" : "")}
      ${selectedStore.pickupLocation.address.postcode}
      </p>
      <p>Distance: ${selectedStore.distance.toFixed(2)} miles</p>
    `;
*/
    formContainer.style.display = "block";
    setTimeout(() => {
      formContainer.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);

    // Update our hidden fields for when we post the form
    const storeAddress = selectedStore.pickupLocation.address;
    console.info("selectedStore details 4", {
      selectedStore,
      storeAddress,
      pickupLocationCode: selectedStore.pickupLocation.pickupLocationCode,
    });
    document.getElementById("store-organisation").value =
      storeAddress.organisation || "";
    document.getElementById("store-property").value =
      storeAddress.property || "";
    document.getElementById("store-street").value = storeAddress.street || "";
    document.getElementById("store-locality").value =
      storeAddress.locality || "";
    document.getElementById("store-town").value = storeAddress.town || "";
    document.getElementById("store-county").value = storeAddress.county || "";
    document.getElementById("store-postcode").value =
      storeAddress.postcode || "";
    document.getElementById("store-countryCode").value =
      storeAddress.countryCode || "";
    document.getElementById("store-locationID").value =
      selectedStore.pickupLocation.pickupLocationCode || "";
  }

  const maxStoresToInitiallyShow = 6;

  if (results.length >= maxStoresToInitiallyShow) {
    showMoreButton.addEventListener("click", () => {
      console.info("Show more button clicked");
      listItems.forEach((item) => (item.style.display = "inline-block"));
      showMoreButton.style.display = "none";
    });
    showMoreButton.style.display = "block";
  }

  results.forEach((result, index) => {
    const location = result.pickupLocation;
    const position = {
      lat: location.addressPoint.latitude,
      lng: location.addressPoint.longitude,
    };
    const markerView = new google.maps.marker.AdvancedMarkerElement({
      map,
      position,
      content: createMarkerContent(index + 1),
    });
    markers.push(markerView);

    const listItem = document.createElement("div");
    if (index >= maxStoresToInitiallyShow) {
      listItem.style.display = "none"; // Initially hide
    }

    listItem.innerHTML = `
      <p style="margin-bottom:5px">${result.distance.toFixed(2)} miles</p>
      <h3 class="body-large-bold">${
        location.address.organisation || location.shortName
      }</h3>
      <p><span style="text-transform: capitalize">${location.address.street.toLowerCase()}, ${
      location.address.town ? location.address.town?.toLowerCase() + ", " : ""
    }</span> ${location.address.postcode}</p>
      <button>Drop off here</button>
    `;
    const dropOffButton = listItem.querySelector("button");
    console.info("Drop off button", dropOffButton);
    dropOffButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation(); // This stops the event from bubbling up
      updateSelectedStore(index);
    });
    listItem.classList.add("widget-card");
    listItem.classList.add("map-card");
    listItems.push(listItem);
    listContainer.appendChild(listItem);

    // Add click event to marker
    markerView.addListener("click", () => {
      console.info("Clicked on a marker", index);
      highlightListItem(index);
      map.panTo(position);
    });

    // Add click event to list item
    listItem.addEventListener("click", () => {
      console.info("Clicked on a info panel", index);
      highlightMarker(index);
      map.panTo(position);
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (typeof loadButton != "undefined" && loadButton != null) {
    loadButton.addEventListener("click", (e) => {
      e.preventDefault();
      ajaxLoadMore();
    });
  }

  if (typeof searchForm != "undefined" && searchForm != null) {
    searchForm.addEventListener("submit", (e) => {
      e.preventDefault();
      ajaxLoadMore();
    });
  }

  if (window.IdealPostcodes) {
    IdealPostcodes.PostcodeLookup.setup({
      apiKey: "ak_m0ff56hmDWEV1DSibrJEO0Kf1r2Et",
      context: "#lookup_field",
      button: "#search-btn",
      input: "#search-postcode",
      selectSinglePremise: true,
      selectStyle: {
        backgroundColor: "#03000d",
        border: 0,
        width: "100%",
        borderRadius: "8px",
        padding: "16px",
        fontWeight: 300,
        letterSpacing: ".06em",
        border: "2px solid #422566",
        color: "#fff",
        marginBottom: "8px",
        transition: ".4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        resize: "none",
      },
      strictlyPostcodes: true,
      hide: [
        "#addressLine1Wrapper",
        "#addressLine2Wrapper",
        "#addressLine3Wrapper",
        "#townWrapper",
        "#postcodeWrapper",
      ],
      unhideClass: "",
      msgUnhide: "Or enter manually",
      outputFields: {
        line_1: "#addressLine1",
        line_2: "#addressLine2",
        line_3: "#addressLine3",
        post_town: "#town",
        postcode: "#postcode",
      },
      onUnhide: () => {
        document.getElementById("FaultDetails").style.display = "inline-block";
      },
    });
  } else {
    //  console.warn("Cannot find PostcodeLookup module, have you included it?");
  }
});
